import React from "react";
import { LOGO_URL } from "../../lib/site-data";

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="py-10 bg-brand-ink text-white/60 border-t border-white/10">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-2.5">
                    <img src={LOGO_URL} alt="Glow Momentz" className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20" />
                    <span className="font-display text-lg text-white">Glow Momentz</span>
                </div>
                <p className="text-xs tracking-wide">
                    © {new Date().getFullYear()} Glow Momentz · Hand-made in Pittsburg, CA with love.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
